import React from "react";
import { useStyle } from "./styles";
import FormFour from "./AllForms/FormFour";

function EditDriver() {
  const classes = useStyle();

  return (
    <div className={classes.mainContainer}>
      <div className={classes.box}>
        {/* <FormOne /> */}
        {/* <FormTwo /> */}
        {/* <FormThree /> */}
        <FormFour />
      </div>
    </div>
  );
}

export default EditDriver;
